import React, { lazy, Suspense } from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import withFeatureFlags from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import { WithFeatureFlagsProps } from '@wix/da-shared-react/pkg/MediaPopup/_hocs/withFeatureFlags';
import ConditionalWrapper from '@wix/da-shared-react/pkg/ConditionalWrapper';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import { default as Custom, Props } from './Custom';
import reduxConnectContainer from './Custom.container';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import WidgetPaywall from '../_partials/paywalls/WidgetPaywall';

const Edit = lazy(() => import(/* webpackChunkName: "owner" */ './Edit'));

const enhance = compose(withFeatureFlags, reduxConnectContainer);
const CustomBox: React.FC<
  Props & WidgetBoxProps & WithFeatureFlagsProps
> = props => {
  const {
    title,
    moduleId,
    widgetMoveUp,
    widgetRemove,
    widgetMoveDown,
    isCurrentUserCoreMember,
    isOwner,
    section,
    flags,
    zone,
  } = props;
  const { t } = useTranslation();

  const renderEditMenu = closeMenu => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <Edit
          moduleId={moduleId}
          onRequestClose={closeMenu}
          widgetRemove={widgetRemove}
        />
      </Suspense>
    );
  };

  const isNewCustombox = flags.includes('custombox_left');

  return (
    <WidgetBox
      section={section}
      zone={zone}
      moduleId={moduleId}
      header={title || t('widgets.custombox.header')}
      autoShowWidgetConfig={true}
      widgetMenuRenderer={closeMenu => renderEditMenu(closeMenu)}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      editControlsTooltipContent={
        !isCurrentUserCoreMember && t('widgets.custombox.edit.tooltip')
      }
    >
      <ConditionalWrapper
        condition={isNewCustombox && isOwner && !isCurrentUserCoreMember}
        wrap={child => <WidgetPaywall>{child}</WidgetPaywall>}
      >
        <Custom {...props} isNewCustombox={isNewCustombox} />
      </ConditionalWrapper>
    </WidgetBox>
  );
};

CustomBox.displayName = 'CustomBox';

export default enhance(CustomBox);
